// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qz tu","ribbon":"qA tD","title":"qB tw","seasons":"qC tB","genres":"qD tC","buttonWrapper":"qE ty","button":"qF tz"};